const INITIAL_STATE = {
  all: [],
  current: null,
}

export default {
  namespaced: true,
  state: {
    ...INITIAL_STATE,
  },
  getters: {
    find: (state) => (id) => state.find(el => el.id === id),
  },
  mutations: {
    setCurrent: (state, { item }) => {
      state.current = item
    },
    add: (state, { item, prepend = false }) => {
      if (prepend) {
        state.all.unshift(item)
      } else {
        state.all.push(item)
      }
    },
    remove: (state, { id }) => {
      let idx = state.all.findIndex(el => el.id === id)
      state.all.splice(idx, 1)
    },
    
  },
  actions: {
    plist: ({ dispatch, getters, commit }, { id }) => {
      let headers = {
        'Content-Type': 'application/json',
      }
      Object.assign(headers, getters.getAuthHeader)
      
      return dispatch('apiRequest', {
        actionPath: ['/applications/plist/', id, '.xml'].join(''),
        method: 'get',
        headers: headers,
        
      }, { root: true }).then(result => {
        
        commit('addClient', result)
        
        return Promise.resolve(result)
      })
    }, status: ({ dispatch, getters, commit }) => {
      let headers = {
        'Content-Type': 'application/json',
      }
      Object.assign(headers, getters.getAuthHeader)
      
      return dispatch('apiRequest', {
        actionPath: '/applications/status.json',
        method: 'get',
        headers: headers,
        
      }, { root: true }).then(result => {
        
        commit('addClient', result)
        
        return Promise.resolve(result)
      })
    },
  },
}